export default {
  liveStats: {
    openVsx: { publisher: 'juanlias', name: 'ultra-instinct-theme' },
    marketplace: { publisher: 'JuanLias', name: 'ultra-instinct-theme' },
  },
  meta: {
    title: 'ULTRA INSTINCT THEME',
    headline: 'Hacia <br> <span class="text-electric-purple">El Vacío.</span>',
    label: 'Case Study 04',
    description:
      'Una trilogía de temas para VS Code diseñada para desarrolladores neurodivergentes, eliminando el ruido visual para alcanzar el foco absoluto.',
    chips: [
      { text: 'Open Source', dotColor: 'bg-electric-purple' },
      { text: 'VS Code', dotColor: 'bg-blue-500' },
      { text: '2026' },
    ],
    heroImage:
      'https://images.unsplash.com/photo-1629654297299-c8506221ca97?q=80&w=1920&auto=format&fit=crop',
    heroLogo:
      'https://raw.githubusercontent.com/juanlias/ultra-instinct-theme/master/images/icon.png',
  },
  sidebar: {
    title: 'Índice',
    meta: [
      { label: 'Autor', value: 'Juan Lias' },
      { label: 'Tipo', value: 'Extensión de VS Code' },
      { label: 'Rol', value: 'Diseñador & Desarrollador' },
      { label: 'Stack', value: 'JSON, TypeScript, VS Code API' },
      { label: 'Versión', value: 'v0.1.3' },
      { label: 'Licencia', value: 'MIT Open Source' },
      { label: 'Año', value: '2026' },
    ],
    cta: 'Ver en GitHub',
    ctaLink: 'https://github.com/juanlias/ultra-instinct-theme',
    repoLink: 'https://github.com/juanlias/ultra-instinct-theme',
  },
  sections: {
    overview: {
      id: 'overview',
      menuLabel: 'Overview',
      title: 'El Proyecto',
      highlight:
        'Ultra Instinct es una trilogía de temas para VS Code diseñada desde una perspectiva neurodivergente — una interfaz construida para desaparecer y que la lógica tome el protagonismo.',
      cards: [
        {
          title: 'El Vacío',
          text: 'Diseño ultra-minimal que elimina la fricción cognitiva: sin bordes innecesarios, sin contrastes molestos, sin corchetes arcoíris.',
        },
        {
          title: 'Tres Variantes',
          text: 'Sign (depuración intensa), Mastered (flujo cotidiano tranquilo) y Mastered Light (entornos iluminados) — cada uno sintonizado a un estado mental.',
        },
        {
          title: 'WCAG 2.1 AA',
          text: 'Todos los ratios de contraste superan 4.5:1. El desarrollo de alto rendimiento no debería costar sobrecarga sensorial.',
        },
      ],
    },
    enfoque: {
      id: 'enfoque',
      menuLabel: 'Filosofía',
      label: 'Filosofía de Diseño',
      title: 'El Concepto del Vacío',
      description:
        'Como desarrollador con <strong>Autismo y Alto Potencial</strong>, los temas estándar me resultaban cognitivamente abrumadores — cada borde innecesario y contraste brusco rompía mi concentración. Ultra Instinct nació para resolver mi propio problema: una interfaz amigable sensorialmente que se desvanece, dejando solo el código.',
      tags: [
        'Diseño Neurodivergente',
        'Sensorial Friendly',
        'WCAG 2.1 AA',
        'Foco Profundo',
        'Estado de Flujo',
      ],
    },
    problema: {
      id: 'problema',
      menuLabel: 'El Desafío',
      title: 'El Problema',
      description:
        'Los temas estándar están construidos para el desarrollador promedio. Para los programadores neurodivergentes, los colores intensos, bordes excesivos y corchetes arcoíris generan interrupciones sensoriales constantes que rompen el estado de flujo y provocan fatiga cognitiva.',
      stats: [
        { value: 'v0.1.3', label: 'Versión', liveKey: 'version' },
        { value: '128+', label: 'Marketplace', liveKey: 'marketplaceInstalls' },
        { value: '5K+', label: 'Open VSX', liveKey: 'openVsxDownloads' },
      ],
    },
    branding: {
      id: 'branding',
      menuLabel: 'Paleta',
      title: 'Variantes del Tema',
      description:
        'Tres sistemas de color distintos, cada uno orientado a un estado mental y entorno de trabajo diferente.',
      palette: [
        { name: 'Sign — Carbón Profundo', hex: '#0d1017' },
        { name: 'Sign — Azul Eléctrico', hex: '#82aaff' },
        { name: 'Sign — Índigo', hex: '#7986cb' },
        { name: 'Mastered — Vacío Oscuro', hex: '#141118' },
        { name: 'Mastered — Púrpura Real', hex: '#a78bfa' },
        { name: 'Mastered — Plata', hex: '#94a3b8' },
        { name: 'Light — Plata Divina', hex: '#e8eaf6' },
        { name: 'Light — Púrpura Aura', hex: '#7c3aed' },
      ],
      typography:
        'Ultra Instinct Sign (Depuración intensa) · Mastered (Trabajo diario) · Mastered Light (Presentaciones y entornos iluminados)',
    },
    tecnologia: {
      id: 'tecnologia',
      menuLabel: 'Tech Stack',
      title: 'Por Dentro',
      categories: [
        { name: 'Formato', items: ['JSON Theme Spec', 'VSIX Package'] },
        { name: 'Estándares', items: ['WCAG 2.1 AA', 'Licencia MIT', 'Versionado Semántico'] },
      ],
    },
    footer: {
      prev: null,
      next: { label: 'Siguiente Case', title: 'Hyperdrive', link: '/works/hyperdrive' },
    },
  },
}
